<template>
  <div>
    <div
      data-ix="hide-fixed-top-wrapper"
      class="w-hidden-small w-hidden-tiny fixed-block-top-wrapper"
    >
      <div class="w-container container with-fixed-block">
        <div class="fixed-block-wrapper">
          <a
            href="#"
            data-ix="close-fixed-bar"
            class="w-inline-block fixed-block-close-button"
          >
            <img
              src="/images/Icon-close-thin.png"
              class="close-icon"
            >
          </a>
          <Sidebar />
        </div>
      </div>
    </div>
    <Navbar />
    <BlogPostDetail
      v-if="post"
      :post="post"
    />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/TheNavbar'
import Sidebar from '@/components/TheSidebar'
import Footer from '@/components/TheFooter'
import BlogPostDetail from '@/components/BlogPostDetail'

export default {
  components: {
    Navbar,
    Sidebar,
    Footer,
    BlogPostDetail,
  },

  props: {
    slug: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      content: '',
    }
  },

  computed: {
    post() {
      return this.$store.getters.getPostBySlug(this.slug)
    },
  },

  created() {
    if (!this.$store.posts) {
      this.$store.dispatch('fetchPosts').then(() => {})
    }
  },

  mounted() {
    // eslint-disable-next-line
    $(Webflow.destroy)
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },

  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },
}
</script>

<style>
.article-container {
  min-height: 700px;
}
.blog-author-image {
  background-size: contain;
}
</style>
